jQuery($ => {
    class CircularContentSlider {
      constructor(element) {
        this._                    = element;
        this._element             = $(element);
        this._slider              = this._element.find('enhanced-css-slider');
        this._indicators          = this._element.find('.o-circular-content-slider__indicator');
        this._indicatorsContainer = this._element.find('.o-circular-content-slider__indicators');
        this._arrowButtons        = this._element.find('.m-slider-navigation__arrow');
        this._images              = this._element.find('.o-circular-content-slider__circle-image');
        this._line                = this._element.find('.o-circular-content-slider__line');
        this._heading             = this._element.find('.o-circular-content-slider__heading');
        this._circleContainer     = this._element.find('.o-circular-content-slider__circle-container');
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );

        this.handleHeadingHeightAdjustments();
      }

      handleHeadingHeightAdjustments() {
        const headingIdealHeight = 172;
        const headingHeight = this._heading.innerHeight();
        const headingHeightDiff = headingHeight - headingIdealHeight;

        // If window <= 768px, set top to unset
        if (window.innerWidth <= 768) {
          this._circleContainer.css('top', 'unset');
        } else {          
          if (headingHeightDiff > 0) {
            this._circleContainer.css('top', `${headingHeightDiff}px`);
          }
        }
      }

      handleActiveIndicator(activeSlide, hasFinishedChange = false) {
        const { _indicators, _indicatorsContainer, _images, _line, _slider } = this;

        // Must match the rules in the scss file
        let rotationOffset = -72;
        // If window < 768px, its -144
        if (window.innerWidth < 768) {
          rotationOffset = -144;
        }

        // Adjust active slide to 1-based index
        activeSlide = activeSlide + 1;
        _indicatorsContainer.attr('data-position', activeSlide);

        // Calculate rotation values
        const indicatorCount = _indicators.length;
        const circleSliceSize = 360 / indicatorCount;
        const circleWidth = _indicatorsContainer.width();

        // Get previous and new rotation values
        const previousRotation = parseFloat(_indicatorsContainer.attr('data-rotation')) || 0;
        let newRotation = 0;     

        if (activeSlide > 1) {
          newRotation = -circleSliceSize * (activeSlide - 1);
        }

        let rotationDiff = newRotation - previousRotation;
        // Adjust rotationDiff to choose the shortest path
        if (rotationDiff > 180) {
          rotationDiff -= 360;
        } else if (rotationDiff < -180) {
          rotationDiff += 360;
        }
        
        newRotation = previousRotation + rotationDiff;

        // Update rotation attributes and styles
        _indicatorsContainer.attr('data-rotation', newRotation)
            .css('rotate', `${newRotation}deg`);

        // Iterate through indicators to set their transform and active class
        _indicators.each((index, indicator) => {
            const $indicator = $(indicator);
            const itemRotation = circleSliceSize * index;
            const transform = `rotate(${itemRotation}deg) translate(0, -${circleWidth / 2}px) rotate(${(itemRotation + newRotation + rotationOffset) * -1}deg)`;

            $indicator.css('transform', transform)
                .toggleClass('o-circular-content-slider__indicator--active', index + 1 === activeSlide);
        });

        // Iterate through images to set their active class
        _images.each((index, image) => {
          $(image).toggleClass('o-circular-content-slider__circle-image--active', index + 1 === activeSlide);
        });

        // Reset line position
        _line.css('width', `0px`);

        if (hasFinishedChange) {          
          // Calculate distance between right of the heading in active slide and right of _line
          const activeSlideElement = _slider.find('.o-circular-content-slider__item:not(.fake)')[activeSlide - 1];
          const slideHeading = $(activeSlideElement).find('.m-content__heading');
          const slideRight = slideHeading[0].getBoundingClientRect().right;
          const lineRight = _line[0].getBoundingClientRect().right;
          const distance = lineRight - slideRight - 20;


          setTimeout(() => {            
            // Set line width to be that distance
            _line.animate({width: `${distance}px`}, 500);            
          }, 100);
        }

      }

      setupHandlers() {
        this._slider.on('slideChanged', (event) => {
          this.handleActiveIndicator(event.detail.activeSlide, true);
        });

        this._indicators.on('click', (event) => {
          const index = $(event.currentTarget).attr('data-index');
          const isAlreadyActive = this._indicatorsContainer.attr('data-position') == index;

          this.handleActiveIndicator(index - 1, isAlreadyActive);
          this._slider[0].scrollToIndex(index - 1);
        });

        this._arrowButtons.on('click', (event) => {
          const target = $(event.currentTarget);
          if (target.hasClass('prev')) {
            let nextSlide = parseInt(this._indicatorsContainer.attr('data-position')) - 1;

            if (nextSlide < 1) {
              nextSlide = this._indicators.length;
            }

            this.handleActiveIndicator(nextSlide - 1);
          } else {
            let nextSlide = parseInt(this._indicatorsContainer.attr('data-position')) + 1;

            if (nextSlide > this._indicators.length) {
              nextSlide = 1;
            }

            this.handleActiveIndicator(nextSlide - 1);
          }
        });

        $(window).on('resize', () => {
          this.handleHeadingHeightAdjustments();
        });
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.circular_content_slider = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].circular_content_slider = new CircularContentSlider(_[i], opt);
        else
          ret = _[i].circular_content_slider[opt].apply(_[i].circular_content_slider, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.o-circular-content-slider').circular_content_slider();
});